<template>
  <div class="menu__container">
    <ul class="menu">
      <li
        v-for="(item, index) in items"
        :key="`item-${index + 1}`"
        v-show="item.visible"
        class="menu__item menu__item--icon"
      >
        <MenuItemLink v-if="!item.subitems" :item="item" />
        <ul
          v-else
          class="submenu__container"
          :class="{ 'submenu__container--open': item.path === routePath }"
        >
          <li class="menu__item menu__item--icon">
            <MenuDropdownAction :item="item" />
            <MenuDropdownItems :items="item.subitems" />
          </li>
        </ul>
      </li>
    </ul>

    <div class="menu__divider" />

    <ul v-if="hasMainMenuOpen || isMobileDevice" class="menu">
      <li v-show="hasRole('custom', 'ROLE_POST_REQUEST_API_TOKEN')" class="menu__item">
        <router-link :to="{ name: 'RequestToken' }">
          <span>{{$t(`${namespace}.requestApiToken`)}}</span>
        </router-link>
      </li>

      <li class="menu__item">
        <a @click.prevent="handleClickFaq">
          <span>{{$t(`${namespace}.faq`)}}</span>
        </a>
      </li>
    </ul>

    <div v-else class="main-menu__arrow--down" @click="handleMainManuToogle">
      <v-icon color="gray-4">keyboard_arrow_down</v-icon>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { hasRole } from 'utils/functions'
import { createHideLink } from 'corp-front-vue-commons/src/utils/functions'
import mediaQueries from 'mixins/mediaQueries'
import MenuItemLink from 'components/Navbar/menu/MenuItemLink'
import MenuDropdownAction from 'components/Navbar/menu/MenuDropdownAction'
import MenuDropdownItems from 'components/Navbar/menu/MenuDropdownItems'

export default {
  name: 'Menu',
  mixins: [mediaQueries],
  components: {
    MenuItemLink,
    MenuDropdownAction,
    MenuDropdownItems
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    },

    routePath () {
      return this.$route.meta.path
    },

    items () {
      return [
        {
          title: 'employees',
          icon: 'employees',
          route: { name: 'Employees' },
          visible: hasRole('menu', 'ROLE_MENU_EMPLOYEES')
        },
        {
          title: 'users',
          icon: 'star',
          route: { name: 'Users' },
          // visible: hasRole('menu', 'ROLE_MENU_USERS')
          visible: false
        },
        {
          title: 'config',
          icon: 'config',
          path: 'config',
          // visible: hasRole('menu', 'ROLE_MENU_COMPANY') ||
          //   hasRole('menu', 'ROLE_MENU_COSTCENTER') ||
          //   hasRole('menu', 'ROLE_MENU_PROJECTS') ||
          //   hasRole('menu', 'ROLE_MENU_USAGEPOLICIES') ||
          //   hasRole('employee', 'ROLE_GET_EMPLOYEE_RIDECREDIT'),
          visible: false,
          subitems: [
            {
              title: 'company',
              route: { name: 'Company' },
              visible: hasRole('menu', 'ROLE_MENU_COMPANY')
            },
            {
              title: 'costCenter',
              route: { name: 'CostCenters' },
              visible: hasRole('menu', 'ROLE_MENU_COSTCENTER')
            },
            {
              title: 'projects',
              route: { name: 'Projects' },
              visible: hasRole('menu', 'ROLE_MENU_PROJECTS')
            },
            {
              title: 'usagePolicies',
              route: { name: 'UsagePolicies' },
              visible: hasRole('menu', 'ROLE_MENU_USAGEPOLICIES')
            },
            {
              title: 'creditPolicies',
              route: { name: 'CreditPolicies' },
              visible: hasRole('employee', 'ROLE_GET_EMPLOYEE_RIDECREDIT')
            }
          ]
        },
        {
          title: 'reports',
          icon: 'reports',
          route: { name: 'Reports' },
          // visible: hasRole('menu', 'ROLE_MENU_REPORTS')
          visible: false
        },
        {
          title: 'financial',
          icon: 'financial',
          path: 'financial',
          // visible: hasRole('menu', 'ROLE_MENU_FINANCIAL') ||
          //   (hasRole('menu', 'ROLE_MENU_FINANCIAL_ADJUSTMENT')) ||
          //   hasRole('financial', 'ROLE_GET_ORDER_REPROCESS') ||
          //   hasRole('custom', 'ROLE_POST_PROCESS') ||
          //   hasRole('financial', 'ROLE_GET_FINANCE_SUMMARY'),
          visible: false,
          subitems: [
            {
              title: 'invoiceHistory',
              route: { name: 'InvoiceHistory' },
              visible: hasRole('menu', 'ROLE_MENU_FINANCIAL')
            },
            {
              title: 'financialAdjustments',
              route: { name: 'FinancialAdjustments' },
              visible: hasRole('menu', 'ROLE_MENU_FINANCIAL_ADJUSTMENT')
            },
            {
              title: 'manualRetrieval',
              route: { name: 'ManualRetrieval' },
              visible: hasRole('financial', 'ROLE_GET_ORDER_REPROCESS')
            },
            {
              title: 'importNfe',
              route: { name: 'ImportNfe' },
              visible: hasRole('custom', 'ROLE_POST_PROCESS')
            },
            {
              title: 'revenues',
              route: { name: 'Revenues' },
              visible: hasRole('financial', 'ROLE_GET_FINANCE_SUMMARY')
            }
          ]
        },
        {
          title: 'searchByPhone',
          icon: 'phone',
          route: { name: 'SearchPhone' },
          visible: hasRole('menu', 'ROLE_MENU_CELPHONE_SEARCH')
        }
      ]
    }
  },
  data () {
    return {
      namespace: 'Components.MainMenu'
    }
  },
  methods: {
    ...mapActions({
      handleMainManuToogle: 'mainMenu/toggle'
    }),

    hasRole (group, role) {
      return hasRole(group, role)
    },

    handleClickFaq () {
      this.$ga.page('/faq')
      createHideLink('https://99empresas.zendesk.com', '_blank')
    }
  }
}
</script>

<style lang="scss">
@import './styles.scss';
</style>
